
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { VBox } from './Box'
import './css/apex.css'

/**
 * App is a generic application wrapper, it should be
 * the outer-most element at the mount point.
 */

export default function App({ children }) {
  return <Router>
    <VBox
      displayName="App"
      width="100vw"
      height="100vh"
      overflow="hidden"
      background={1}
    >
      {children}
    </VBox>
  </Router>
}
 